var render, staticRenderFns
import script from "./JeepayTableColumns.vue?vue&type=script&lang=js"
export * from "./JeepayTableColumns.vue?vue&type=script&lang=js"
import style0 from "./JeepayTableColumns.vue?vue&type=style&index=0&id=4ac19d48&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac19d48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ac19d48')) {
      api.createRecord('4ac19d48', component.options)
    } else {
      api.reload('4ac19d48', component.options)
    }
    
  }
}
component.options.__file = "src/components/JeepayTable/JeepayTableColumns.vue"
export default component.exports